/**
 * Mapbox supported worldviews for administrative boundaries
 * Based on official Mapbox documentation: https://docs.mapbox.com/mapbox-gl-js/example/toggle-worldviews/
 */
export enum MapboxWorldview {
    /** China worldview */
    CN = "CN",
    /** India worldview */
    IN = "IN",
    /** Japan worldview */
    JP = "JP",
    /** United States/International worldview (default) */
    US = "US",
    /** Morocco worldview */
    MA = "MA",
}

export const getSupportedWorldviews = (): string[] => {
    return Object.values(MapboxWorldview);
};

export const isSupportedWorldview = (countryCode: string): countryCode is MapboxWorldview => {
    return Object.values(MapboxWorldview).includes(countryCode as MapboxWorldview);
};
